import React from 'react';
import tw from 'twin.macro';

const ReadingTime = ({ text }) => <span tw="opacity-50 mb-0 text-sm leading-tight">{text}</span>;

export default ReadingTime;
